import * as types from "./types.js"
import * as api from "./api.js"


function getMedicalsRequest() {
    return {
        type: types.GET_MEDICALS_REQUEST
    }
}

function getMedicalsReceived(medicals) {
    return {
        type: types.GET_MEDICALS_RECEIVED,
        payload: medicals
    }
}

function getMedicalsError(e) {
    return {
        type: types.GET_MEDICALS_ERROR,
        payload: e,
        error: true
    }
}

export function getMedicals(personid) {
    return dispatch => {
        dispatch(getMedicalsRequest())
        return api.getMedicals(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getMedicalsError(res.statusText))
            } else {
                return res.json()
                .then(medicals => {
                    dispatch(getMedicalsReceived(medicals))
                })
            }
        })
    }
}


function postMedicalRequest() {
    return {
        type: types.POST_MEDICAL_REQUEST
    }
}

function postMedicalReceived(medical) {
    return {
        type: types.POST_MEDICAL_RECEIVED,
        payload: medical
    }
}

function postMedicalError(e) {
    return {
        type: types.POST_MEDICAL_ERROR,
        payload: e,
        error: true
    }
}

export function postMedical(medical) {
    return dispatch => {
        dispatch(postMedicalRequest())
        return api.postMedical(medical)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postMedicalError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postMedicalReceived({
                        id: stats.id,
                        medical: medical.medical,
                        valid: medical.valid
                    }))
                })
            }
        })
    }
}


function putMedicalRequest() {
    return {
        type: types.PUT_MEDICAL_REQUEST
    }
}

function putMedicalReceived(medical) {
    return {
        type: types.PUT_MEDICAL_RECEIVED,
        payload: medical
    }
}

function putMedicalError(e) {
    return {
        type: types.PUT_MEDICAL_ERROR,
        payload: e,
        error: true
    }
}

export function putMedical(medical) {
    return dispatch => {
        dispatch(putMedicalRequest())
        return api.putMedical(medical)
        .then(res => {
            if (res.status !== 200) {
                dispatch(putMedicalError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(putMedicalReceived({
                        id: medical.id,
                        medical: medical.medical,
                        valid: medical.valid
                    }))
                })
            }
        })
    }
}


function deleteMedicalRequest() {
    return {
        type: types.DELETE_MEDICAL_REQUEST
    }
}

function deleteMedicalReceived(medical) {
    return {
        type: types.DELETE_MEDICAL_RECEIVED,
        payload: medical
    }
}

function deleteMedicalError(e) {
    return {
        type: types.DELETE_MEDICAL_ERROR,
        payload: e,
        error: true
    }
}

export function deleteMedical(id) {
    return dispatch => {
        dispatch(deleteMedicalRequest())
        return api.deleteMedical(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteMedicalError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteMedicalReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/medicals/actions.js
 **/